import { Typography, Box, Container, Divider } from "@material-ui/core";

export default function Footer() {
  return (
    <Box mt= {3}>
      <Container maxWidth="md" >
        <Divider/> 
        <Box py={3}>
      <Typography variant="body2" align="center">
        {"Copyright © Adzkiya Games "}
        {new Date().getFullYear()}.
      </Typography>
          </Box>   
      </Container>
    </Box>
  );
}
